import { buttonStyle } from 'components/buttons/buttonStyle';
import { PinIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import { Tooltip } from 'components/ui/tooltip';
import React from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

interface Props {
    enabled: boolean;
    onChange: (enabled: boolean) => void;
}

/**
 * Remember filters as a square pin button the height of the Filter button beside it: an outlined pin when off, a
 * filled one on the green surface when on. The tooltip says what a click does; the name and `aria-pressed` say it
 * to assistive tech.
 */
const FilterPersistenceToggle: React.FC<Props> = ({ enabled, onChange }) => (
    <Tooltip content={t(enabled ? 'remember-filters-on' : 'remember-filters')}>
        <Button
            {...buttonStyle(
                { variant: 'outlined' },
                cn(
                    'text-grey-600 hover:text-grey-700 aspect-square px-0',
                    enabled &&
                        'border-primary bg-primary-surface text-primary hover:bg-primary-subtle hover:text-primary'
                )
            )}
            aria-label={t('remember-filters')}
            aria-pressed={enabled}
            onClick={() => onChange(!enabled)}
        >
            <PinIcon className={cn('size-4', enabled && 'fill-current')} />
        </Button>
    </Tooltip>
);

export default FilterPersistenceToggle;
